import { API } from "aws-amplify";
import {
  COGNITO_PREFERRED_USERNAME,
  STRIPE_SUBSCRIPTION_EXPIRY,
  STRIPE_SUBSCRIPTION_STATUS,
  STRIPE_SUBSCRIPTION_ID,
  API_USER_MANAGEMENT,
  GROUP_ADMINISTRATOR,
  GROUP_MODERATOR,
  GROUP_OPERATOR,
  ROLE_ADMIN,
  ROLE_MODERATOR,
  ROLE_OPERATOR,
  ROLE_STANDARD,
  ROLE_GUEST
} from "../../constants";

// Re-export constants for backward compatibility
export const STRIPE_SUB_EXPIRY = STRIPE_SUBSCRIPTION_EXPIRY;
export const STRIPE_SUB_STATUS = STRIPE_SUBSCRIPTION_STATUS;
export const STRIPE_SUBSCR_ID = STRIPE_SUBSCRIPTION_ID;
export const STRIPE_SUBSCR_ID_SEARCHABLE = COGNITO_PREFERRED_USERNAME;

export const a = "UserAttributes.at('sub').Value";

export async function getCognitoUser(cognitoSub) {
  const myAPI = API_USER_MANAGEMENT;
  const path = "/user";

  const result = await API.get(myAPI, path, {
    queryStringParameters: {
      username: cognitoSub, // OPTIONAL
    },
  });
  const code = result.user.statusCode;
  const user = result.user.user;
  return { code, user };
}

export function getUserAttributeAt(cognitoUser, key) {
  return cognitoUser.UserAttributes.at(key).Value;
}

export function userIsAdministrator(cognitoUser) {
  let b = false;
  try {
    b = userIsInGroup(cognitoUser, GROUP_ADMINISTRATOR);
  } catch (error) {
    b = false;
  }
  return b;
}

export function userIsModerator(cognitoUser) {
  let b = false;
  try {
    b = userIsInGroup(cognitoUser, GROUP_MODERATOR);
  } catch (error) {
    b = false;
  }
  return b;
}

export function userIsOperator(cognitoUser) {
  let b = false;
  try {
    b = userIsInGroup(cognitoUser, GROUP_OPERATOR);
  } catch (error) {
    b = false;
  }
  return b;
}

/**
 * Get user's role (non-hierarchical)
 * @returns 'ADMIN' | 'MODERATOR' | 'OPERATOR' | 'STANDARD' | 'GUEST'
 */
export function getUserRole(cognitoUser) {
  if (userIsAdministrator(cognitoUser)) return ROLE_ADMIN;
  if (userIsModerator(cognitoUser)) return ROLE_MODERATOR;
  if (userIsOperator(cognitoUser)) return ROLE_OPERATOR;
  if (cognitoUser?.username) return ROLE_STANDARD;
  return ROLE_GUEST;
}

/**
 * Check if user should be blocked from app access
 * Currently operators are blocked (reserved for future use)
 */
export function userIsBlocked(cognitoUser) {
  return userIsOperator(cognitoUser);
}

function userIsInGroup(cognitoUser, groupName) {
  let isMember = false;
  try {
    const groups =
      cognitoUser.signInUserSession.accessToken.payload["cognito:groups"];
    for (const group of groups) {
      if (groupName === group) {
        isMember = true;
        break;
      }
    }
  } catch (error) {
    isMember = false;
  }
  return isMember;
}

export function cognitoUserAttributesToMap(cognitoUser) {
  const mymap = cognitoUser.UserAttributes.reduce(function (map, obj) {
    map[obj.Name] = obj.Value;
    return map;
  }, {});
  return mymap;
}

export function updateUserAttributeViaIndex(cognitoUser, key, value) {
  //Find index of specific object using findIndex method.
  const i = cognitoUser.UserAttributes.findIndex((ob) => ob.Name === key);
  cognitoUser.UserAttributes[i] = value;
  return cognitoUser;
}

